import { createAction } from '@reduxjs/toolkit';

import { REQUEST_FILES_LIST } from '@store/filing/files/files.const';

export const requestFilesList = createAction(REQUEST_FILES_LIST);
